import "./Footer.scss";
import { images } from "../../utils/images";
import { MdOutlineCheck } from "react-icons/md";
import { GrLinkedinOption } from "react-icons/gr";
import { NavLink } from "react-router-dom";
import { paths } from "../../utils/paths";
import { Fragment, useContext, useState } from "react";
import { GoArrowUp } from "react-icons/go";
import axios from "axios";
import { baseUrl, emailSubscribe } from "../../utils/apiData";
import { MdClose } from "react-icons/md";
import { mainContext } from "../../utils/WebContext";
import { FaInstagram } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";

const Footer = () => {
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const [accept, setAccept] = useState(false);
  const [email, setEmail] = useState("");

  const date = new Date();
  const { headerService, involvedService, footerData } =
    useContext(mainContext);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // This makes the scrolling smooth
    });
  };

  const emailHandler = (e) => {
    setEmail(e.target.value);
  };

  const submitHandler = async () => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${emailSubscribe}`, {
        email: `${email}`,
        privacy_policy: accept,
      });
      if (res?.data?.success) {
        setSuccess(true);
        setAccept(false);
        setEmail("");
      }
    } catch (error) {
      console.log(error);
    }
    setLoader(false);
  };
  const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
  return (
    <footer>
      <section className="footer p_t">
        <div className="content_wrap">
          <div className="logo_line">
            <div className="left">
              <img src={images.logoWhite} alt="Logo" />
            </div>
            <div className="social">
              {footerData?.linkedin_link && (
                <a href={footerData?.linkedin_link} target="_blank">
                  <GrLinkedinOption />
                </a>
              )}
              {footerData?.instagram_link && (
                <a href={footerData?.instagram_link} target="_blank">
                  <FaInstagram />
                </a>
              )}
            </div>
          </div>
          <div className="link_grid">
            <div className="link_col">
              <p className="t_18">Quick LInks</p>
              <NavLink to={paths.HOME}>Home</NavLink>
              <NavLink to={paths.ABOUT}>About Us</NavLink>
              <NavLink to={paths.SERVICES}>Services</NavLink>
              <NavLink to={paths.BLOGS}>News & Events</NavLink>

              {headerService?.map((data) => {
                return (
                  <Fragment key={data?._id}>
                    <NavLink to={`/info/${data?.slug}`}>{data?.name}</NavLink>
                  </Fragment>
                );
              })}

              {involvedService?.length > 0 && (
                <NavLink to={`/get-involved/${involvedService?.[0]?.slug}`}>
                  Get Involved
                </NavLink>
              )}
              <NavLink to={paths.CONTACT}>Contact</NavLink>
            </div>
            <div className="link_col">
              <p className="t_18">Registered Office</p>
              <p>
                Aaladamara Foundation,
                <br />
                6th Main Road,
                <br />
                Mogappair Eri Scheme,
                <br />
                Mogappair West, Chennai- 600037
              </p>
            </div>
            <div className="link_col">
              <p className="t_18">Branch Office</p>
              <p>
                Aaladamara Foundation,
                <br />
                Villa No.132, <br />
                Cloud 9 Villas- Prasiddhi Group,
                <br />
                Bommasandra Industrial Area,
                <br />
                Bangalore- 560099
                <br />
                Karnataka
              </p>
            </div>

            <div className="link_col email_col">
              <p className="t_18">SUBSCRIBE FOR UPDATES</p>

              {success ? (
                <div className="success_mail">
                  <button
                    type="button"
                    className="close_mail"
                    onClick={() => setSuccess(false)}
                  >
                    <MdClose />
                  </button>
                  <p>You have subscribed successfully.</p>
                </div>
              ) : (
                <Fragment>
                  <div className="email_field_wrap">
                    <input
                      type="email"
                      placeholder="info@gmail.com"
                      value={email}
                      onChange={emailHandler}
                    />
                    <button
                      type="button"
                      onClick={submitHandler}
                      disabled={!emailRegex.test(email)}
                    >
                      {loader ? "Loading..." : "Subscribe"}
                    </button>
                  </div>

                  <div className="check_wrap">
                    <div
                      className={`box ${accept ? "active" : ""}`}
                      onClick={() => setAccept((prev) => !prev)}
                    >
                      {accept && <MdOutlineCheck />}
                    </div>
                    <p className="t_16">
                     I accept the terms of site use and the privacy policy.
                    </p>
                  </div>
                </Fragment>
              )}

              <p className="t_18">Helpline </p>

              {(footerData?.helpline_1_title || footerData?.helpline_1_number) && (
                <p className="tel">
                  {footerData?.helpline_1_title}
                  <br />
                  <a
                    href={`tel:${footerData?.helpline_1_number}`}
                    target="_blank"
                  >
                    <IoCall /> {footerData?.helpline_1_number}
                  </a>
                </p>
              )}

              {(footerData?.helpline_2_title || footerData?.helpline_2_number) && (
                <p className="tel">
                  {footerData?.helpline_2_title}
                  <br />
                  <a
                    href={`tel:${footerData?.helpline_2_number}`}
                    target="_blank"
                  >
                    <IoCall /> {footerData?.helpline_2_number}
                  </a>
                </p>
              )}

              {(footerData?.helpline_3_title || footerData?.helpline_3_number) && (
                <p className="tel">
                  {footerData?.helpline_3_title}
                  <br />
                  <a
                    href={`tel:${footerData?.helpline_3_number}`}
                    target="_blank"
                  >
                    <IoCall /> {footerData?.helpline_3_number}
                  </a>
                </p>
              )}
               {(footerData?.helpline_4_title || footerData?.helpline_4_number) && (
                <p className="tel">
                  {footerData?.helpline_4_title}
                  <br />
                  <a
                    href={`tel:${footerData?.helpline_4_number}`}
                    target="_blank"
                  >
                    <IoCall /> {footerData?.helpline_4_number}
                  </a>
                </p>
              )}
            </div>
          </div>
          <div className="copy_right">
            <p className="t_18">
              @ Copyright {date.getFullYear()} by AALADAMARA - all right
              reserved
            </p>
            <div className="right">
              <p className="t_16">Scroll Top</p>
              <button type="button" onClick={scrollToTop}>
                <GoArrowUp />
              </button>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
